<div class="main">
  <div class="mt-0 profile-header">
    <h6>Design Layout & Content:</h6>
  </div>
  <br />
  <div class="row">
    <div class="col-lg-12 design_tab">
      <mat-tab-group>
        <mat-tab label="My Contents">
          <form [formGroup]="contentForm">
            <div class="row">
              <div class="col-md-6 col-sm-12 col-12">
                <mat-form-field class="w-100">
                  <label><strong>Section</strong></label>
                  <mat-select formControlName="contentType">
                    <mat-option *ngFor="let content of contentTypeList" [value]="content.key">
                      {{ content.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 py-2">
                <angular-editor formControlName="content" required [config]="config" name="content"></angular-editor>
              </div>
            </div>
          </form>
        </mat-tab>
        <mat-tab label="Content Ordering">
          <div class="row">
            <div class="col-md-6">
              <h5 class="my-3">Online CMA Report</h5>
              <form [formGroup]="onlineForm">
                <div
                  cdkDropList
                  [cdkDropListData]="onlineCmaList"
                  (cdkDropListDropped)="dropOnline($event)"
                  class="example-list"
                >
                  <div *ngFor="let item of onlineCmaList">
                    <ng-container *ngIf="isArray(item); else singleItemOnline">
                      <div class="example-box grouped-items" cdkDrag>
                        <div *ngFor="let subItem of item">
                          <mat-checkbox
                            class="pr-2"
                            [checked]="isChecked('online', subItem)"
                            (change)="onCheckboxChange('online', subItem, $event.checked)"
                          >
                            {{ subItem }}
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #singleItemOnline>
                      <div class="example-box" cdkDrag>
                        <mat-checkbox
                          class="pr-2"
                          [checked]="isChecked('online', item)"
                          (change)="onCheckboxChange('online', item, $event.checked)"
                        >
                          {{ item }}
                        </mat-checkbox>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-6">
              <h5 class="my-3">PDF Report</h5>
              <form [formGroup]="pdfForm">
                <div
                  cdkDropList
                  [cdkDropListData]="pdfReportList"
                  (cdkDropListDropped)="dropPdf($event)"
                  class="example-list"
                >
                  <div *ngFor="let item of pdfReportList">
                    <ng-container *ngIf="isArray(item); else singleItemPdf">
                      <div class="example-box grouped-items" cdkDrag>
                        <div *ngFor="let subItem of item">
                          <mat-checkbox
                            class="pr-2"
                            [checked]="isChecked('pdf', subItem)"
                            (change)="onCheckboxChange('pdf', subItem, $event.checked)"
                          >
                            {{ subItem }}
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #singleItemPdf>
                      <div class="example-box" cdkDrag>
                        <mat-checkbox
                          class="pr-2"
                          [checked]="isChecked('pdf', item)"
                          (change)="onCheckboxChange('pdf', item, $event.checked)"
                        >
                          {{ item }}
                        </mat-checkbox>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <button mat-flat-button color="primary" class="btn-lg mb-4" type="submit" (click)="submit()">
            <ng-container> Save </ng-container>
          </button>
        </mat-tab>
        <mat-tab label="PDF Theme">
          <h5 class="my-3 pl-2">Select PDF Theme</h5>
          <div class="row">
            <div class="col-md-4 col-sm-6 col-12" *ngFor="let theme of themes">
              <mat-card class="theme-card mat-elevation-z4 p-3 text-center mb-3">
                <img [src]="theme.image" [alt]="theme.name" class="theme-image" height="80px" />
                <h5 class="mt-2">{{ theme.name }}</h5>
                <div class="mt-2">
                  <button mat-flat-button color="primary" class="w-100" type="submit" (click)="viewTheme(theme.name)">
                    View
                  </button>
                </div>
                <div class="mt-2">
                  <button
                    mat-stroked-button
                    color="primary"
                    class="w-100"
                    type="submit"
                    (click)="setDefault(theme.name)"
                  >
                    Set as Default
                  </button>
                </div>
              </mat-card>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div></div>
</div>
